import styled from 'styled-components';
import { NavLink, Link as RouterLink } from 'react-router-dom';

export const Container = styled.div`
  display: flex;
  background: #fff;
  width: 100%;
  flex-wrap: nowrap;
  overflow: hidden;
`;

export const Link = styled(NavLink)<{ $active?: boolean; $disabled?: boolean; $fixed?: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 0 4px;
  font-size: 12px;
  line-height: 24px;
  max-width: 300px;
  min-width: 20px;
  flex: 0 1 auto;
  flex-shrink: ${(props) => (props.$fixed ? 0 : 1)};
  color: ${(props) => (props.$active ? '#fff' : '#262626')};
  background: ${(props) => (props.$active ? '#215bff' : '#f4f6f7')};
  border: 1px solid;
  border-color: ${(props) => (props.$active ? '#215bff' : '#d9d9d9')};
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  text-decoration: none;

  &:hover {
    box-shadow: ${(props) => (props.$disabled ? 'none' : '0 2px 8px rgba(0, 0, 0, 0.15)')};
  }

  &:not(:last-of-type) {
    border-right: none;
  }

  > span {
    white-space: nowrap;
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  button.gm-ant-btn-sm.gm-ant-btn-icon-only {
    flex: none;
    margin-left: 2px;
    width: 16px;
    height: 16px;
    border: none;
    font-size: 10px;
  }
`;

export const BlankFunnelLink = styled(RouterLink)`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d9d9d9;

  button {
    border-radius: 0;
  }
`;
